import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { spacesClient } from '#pplx_generated/typespec/rest/spaces/client.js';
export const listUserPinnedSpaces = async ({ reason, }) => {
    const { data, error, response } = await spacesClient.GET('/rest/spaces/user-pins', reason, {
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to list user pinned spaces',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=listUserPinnedSpaces.js.map